import { ProgressBarStep } from 'components/layout/ProgressBar';
import { URLS } from 'config';

export const QUERY_STEPS: ProgressBarStep[] = [
  {
    type: 'single',
    url: URLS.enquiryWelcome,
  },
  {
    type: 'single',
    url: URLS.enquiryContactDetails,
  },
  {
    type: 'single',
    url: URLS.enquiryWorkDetails,
  },
  {
    type: 'single',
    url: URLS.enquiryProjectBudget,
  },
  {
    type: 'single',
    url: URLS.enquiryComplete,
  },
];

export const QUOTE_STEPS: ProgressBarStep[] = [
  {
    type: 'single',
    url: URLS.enquiryQuoteWelcome,
  },
  {
    type: 'single',
    url: URLS.enquiryQuoteContactDetails,
  },
  {
    type: 'single',
    url: URLS.enquiryQuoteUploadQuote,
  },
  {
    type: 'single',
    url: URLS.enquiryQuoteConfirmDetails,
  },
  {
    type: 'single',
    url: URLS.enquiryQuoteComplete,
  },
];
